<p>ui-sidebar works!</p>
